import React, { useEffect, useState } from 'react'
import { Progress } from 'antd'
import { Wrapper, Title, OverallProgress } from './styled'

interface IProps {
  value: number
  overallProgress: number
}

const Advance = ({ value, overallProgress }: IProps) => {
  const [title, setTitle] = useState('')
  const [color, setColor] = useState('')

  useEffect(() => {
    switch (value) {
      case 0:
        setTitle('Sin comenzar')
        setColor('#FF5B55')
        break
      case 1:
        setTitle('En progreso')
        setColor('#FFC400')
        break
      case 2:
        setTitle('Finalizado')
        setColor('#00B47C')
        break
    }
  }, [value])

  return (
    <Wrapper>
      <Progress
        percent={overallProgress === 0 ? 5 : overallProgress}
        showInfo={false}
        strokeColor={color}
        strokeLinecap='square'
      />
      <Title>{title}</Title>
      <OverallProgress>
        <span>{overallProgress}</span>%
      </OverallProgress>
    </Wrapper>
  )
}

export default Advance
